module.exports = __webpack_public_path__ + "img/ext4.a2014f6c.png";